import React from "react";
import styled from "styled-components";

import { Text } from "src/library/components/Text";

export interface DataLoadErrorProps {
  errorMessage?: string;
}

// Used when there was an error loading widget data. Returns the message displayed center of container
const DataLoadError: React.FunctionComponent<DataLoadErrorProps> = ({ errorMessage }) => {
  return (
    <StyledWrapper>
      <Text weight="bold">
        Unable to load data.
      </Text>

      <br />

      <Text>
        {errorMessage}
      </Text>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export default DataLoadError;